
import { AccountController } from "@/app/ui/controllers/AccountController";
import woodpackingForeignAsset from "@/app/ui/assets/svg/sti-reverse-scan/icon-woodpacking-en.svg";
import woodpackingAsset from "@/app/ui/assets/svg/sti-reverse-scan/icon-woodpacking.svg";
import { Options, Vue, prop } from "vue-class-component";

class Props {
  flag = prop<string>({
    type: String,
    default: "",
  });
  regionName = prop<string>({
    type: String,
    default: "",
  });
  isStiDest = prop<boolean>({
    type: Boolean,
    default: false
  })
}

@Options({})
class WoodpackingIcon extends Vue.with(Props) {
  get woodpackingAsset() {
    return AccountController.accountData.accountIsForeign
      ? woodpackingForeignAsset
      : woodpackingAsset;
  }
}
export default WoodpackingIcon
